
    var riot = require('riot')
    import modalMixin from 'static/script/app/ui/mixin/modal-mixin';
riot.tag2('contact-modal-abort', '<div name="modalBackground" class="modal-background-without-transition modal-default" data-modal-background data-modal-close-trigger riot-style="z-index: 10000; height: {modalHeight}px" data-clickable-list-ignore-click onclick="{onClose}" if="{showModal}"> <div name="modal" class="modal" data-modal> <button class="modal-close" onclick="{onClose}"></button> <div class="messaging-modal-body"> <div class="messaging-modal-body-icon"> <span class="warning--before"></span> </div> <h2 class="messaging-modal-title text-center">Säker på att du vill avbryta?</h2> <p class="messaging-modal-text text-center">Du har börjat skriva ett meddelande, om du avbryter kommer ditt meddelande att försvinna.</p> <button class="secondary-action messaging-modal-message-action" onclick="{onAbort}">Ja avbryt</button> <button class="default-action messaging-modal-message-action" onclick="{onRetry}">Nej fortsätt skriva</button> </div> </div> </div>', '', '', function(opts) {
        this.mixin(modalMixin);

        this.onAbort = function () {
            this.bus.trigger('ui:contact-modal:on-abort');
        }.bind(this);

        this.onRetry = function () {
            this.bus.trigger('ui:contact-modal:on-retry', null);
        }.bind(this);

        this.on('mount', function () {
            this.bus.on('ui:contact-modal:on-retry', this.hide);
            this.bus.on('ui:contact-modal:on-form-close', this.show);
            this.bus.on('ui:contact-modal:on-close', this.close);
        });
});

    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/contact/contact-modal-abort.riot.html